import React from 'react';
import { IOperation } from "../../../../../../util/varibles/interface";
import EtaOperation from '../../../../_components/EtaOperation';
import styles from "./style.module.scss";

const Treatment: React.FC<IOperation> = ({ vessel, operation }) => {
    const { site_name, sub_operations, vessel_name = "" } = operation;
    const { name = vessel_name } = vessel || {};

    const units = sub_operations.map((item: any) => item.unit_id).join(', ');
    const location = [site_name, units].join(' - ');
    return <>
        <div className={styles['line-info']}>
            <div className='flex align-items-center text-truncate'>
                <span className="mr-2">
                    {name}
                </span>
                <EtaOperation data={operation} />
            </div>
        </div>
        <div className={styles['line-info']}>
            <div className='flex align-items-center text-truncate'>{location}</div>
        </div>
    </>;
}

export default Treatment;
